import React from 'react'

const Translate = (props) => {

  const {
    item
  } = props


  function translateType() {
    if(item === 'breakfast'){
      return 'Petit-déjeuner'
    }
    else if(item === 'mealtray'){
      return 'Plateaux-repas'
    }
    else if(item === 'v2'){
      return 'v2'
    }
    else if(item === 'grouped'){
      return 'Prestation'
    }
    else if(item === 'caterer'){
      return 'Traiteur'
    }
    else if(item === '100'){
      return 'Livraison non attribuée'
    }
    else if(item === '110'){
      return 'Livraison attribuée'
    }
    else if(item === '101'){
      return 'Récupération attribuée'
    }
    else if(item === '310'){
      return 'Livraison non faite alors que la date est passée'
    }
    else if(item === '321'){
      return 'Livraison faite mais pas récupérée'
    }
    return 'Problème de trad'
  }

  return (
    <span>
      {translateType()}
    </span>
  )

}

export default Translate
